import i18n from 'i18next';
import { PrayerName } from '../common/enums/PrayersName';

export const localizePrayerName = (prayer: PrayerName | ''): string => {
  if (!prayer) return '';
  return i18n.t(`prayers.${prayer}`);
};
